//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { PojoSet } from 'pojo-sets';

import ClientId from '@models/ClientId';
import GroupId from '@models/GroupId';
import TimeZoneId from '@models/TimeZoneId';
import UserId from '@models/UserId';

export interface IClient {
  name: string;
  id: ClientId;
}

export interface ICuralateGroup {
  name: string;
  id: GroupId;
  brands: IClient[];
}

export interface ICuralateUser {
  id: UserId;
  email: string;
  emailMD5Hash: string;
  firstName: string;
  lastName: string;
  allGroupsAndBrands: ICuralateGroup[];
  portalGuid: string;
  createdAt: string; // This is an ISO8601 Instant
}

// TODO: Finish filling these out
export enum FeatureViewNames {
  dev = 'Dev',
}

export interface IBaseUrls {
  affable_gateway: string;
  web_gateway: string;
  meds: string;
  ops_web: string;
  influencers_gateway: string;
  instagram_dashboard_gateway: string;
  pinterest_dashboard_gateway: string;
  metrics_gateway: string;
  media_api: string;
  facebook_gateway: string;
  feed_gateway: string;
  semantic_tagging_gateway: string;
  syndication_gateway: string;
  experience_gateway: string;
  reveal_v1: string;
  reveal_v2: string;
  screen_capture: string;
  image_insights_gateway: string;
  ipt_gateway: string;
  social_conversations_gateway: string;
  tiktok_gateway: string;
  twitter_gateway: string;
  universal_scheduling_gateway: string;
  user_messaging_gateway: string;
  like2buy_gateway: string;
  sampling_gateway: string;
  social_listening_gateway: string;
  youtube_gateway: string;
}

export interface IBasicCuralateSession {
  baseUrls: IBaseUrls;
  gaId: string;
  instanceId?: string;
  isProduction: boolean;
  timeZone: {
    id: TimeZoneId;
    fullName: string;
    shortName: string;
    offsetMinutes: number;
  };
}

export type SessionFeatureMap = PojoSet<FeatureNames>;

export interface ICuralateSession extends IBasicCuralateSession {
  client: {
    // RIP Consistency, this one is a string instead of a number.
    id: string;
    isClientIdOverrideActive: boolean;
    isSyndication: boolean;
    isShareV2Vendor: boolean;
    name: string;
    createdTimestamp: number;
    contractMRR: string;
    contractStartDate: string;
    contractEndDate: string;
    salesforceBvSiteId?: string;
  };
  dateRange: {
    type: string;
    from: string;
    to: string;
    isOverrideActive: boolean;
  };
  features: SessionFeatureMap;
  group: ICuralateGroup;
  internalInfo: {
    canUserSetFeatureView: boolean;
    elevatedUntil: string;
    featureViewName: FeatureViewNames;
    isCuralateEmployee: boolean;
    isUserElevated: boolean;
    isFacebookAppReview: boolean;
  };
  permissions: PojoSet<string>;
  pinterestUsername: string;
  pinterestUserId: string;
  user: ICuralateUser;
  userRoles: PojoSet<string>;
}
